import { render, staticRenderFns } from "./TabelaClassificacao.vue?vue&type=template&id=28543216&scoped=true"
import script from "./TabelaClassificacao.vue?vue&type=script&lang=js"
export * from "./TabelaClassificacao.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=28543216&prod&scoped=true&lang=scss&external"
import style1 from "./TabelaClassificacao.vue?vue&type=style&index=1&id=28543216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28543216",
  null
  
)

export default component.exports